module.exports = __webpack_public_path__ + "images/4e44b1f61bedf03fa56c98ef1276082b.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/sara_square.jpg
// module id = 139
// module chunks = 24